<template>
  <div>
    <el-alert
      v-show="isMobil"
      class="hidden-sm-and-up"
      title="Warning"
      type="warning"
      center
      :description="$t('notification.mobil_alert')"
      show-icon>
    </el-alert>
    <div class="settings-navigation-container">
      <!-- breadcrumbs -->
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item
          :replace="true"
          :to="{ path: '/app/settings' }">
          {{ $t('settings.overview') }}
        </el-breadcrumb-item>
        <el-breadcrumb-item
          :replace="true"
          v-if="currentCustomer"
          :to="{path: `/app/settings/${currentCustomer.id}/edit`}">
          {{ currentCustomer.name }}
        </el-breadcrumb-item>
        <el-breadcrumb-item
          v-if="$route.path.indexOf('accounts') > 0 && currentCustomer"
          :to="{path: `/app/settings/${currentCustomer.id}/accounts`}">
          {{ $t('settings.customerAccounts') }}
        </el-breadcrumb-item>

        <el-breadcrumb-item
          v-if="$route.path.indexOf('accounts/') > 0 && currentAccount">
          {{ currentAccount.appLoginName }}
        </el-breadcrumb-item>

        <el-breadcrumb-item
          v-if="$route.path.indexOf('account/create') > 0">
          {{ $t('settings.createLocalAccount') }}
        </el-breadcrumb-item>
        <el-breadcrumb-item
          v-if="$route.path.indexOf('customer/create') > 0">
          {{ $t('settings.customerCreate') }}
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <transition mode="out-in" name="el-fade-in">
      <router-view/>
    </transition>
  </div>
</template>

<script>
import {createNamespacedHelpers} from 'vuex';
import {adminAccountService} from "@/services/AdminAccountService.class";

const mspStateMappers = createNamespacedHelpers('msp');
const applicationStateMappers = createNamespacedHelpers('application')


export default {
  name: "Settings",
  data() {
    return {
      currentRoute: null,
      currentCustomer: null,
      currentAccount: null
    }
  },
  computed: {
    ...mspStateMappers.mapGetters(['getCustomer']),
    ...applicationStateMappers.mapGetters({isMobil: 'isMobil'}),
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        this.currentRoute = to;
        this.currentCustomer = this.getCustomer.find(customer => customer.id === to.params.id);
        if (to.params.accountId) {
          this.getAccountById(to.params.accountId);
        }
      }
    },
    getCustomer() {
      this.currentCustomer = this.getCustomer.find(customer => customer.id === this.currentRoute.params.id);
    },
  },
  mounted() {
    this.currentRoute = this.$route;
    this.getCustomersAction();
  },
  methods: {
    ...mspStateMappers.mapActions(['getCustomersAction']),
    onCustomerEdit(data) {
      console.log(data);
    },
    getAccountById(id) {
      adminAccountService.getAccountById(id).then((result) => {
        this.currentAccount = result.data;
      });
    },
    onRowSelected(row) {
      console.log(row);
    }
  }
}
</script>

<style lang="scss" scoped>
.settings-navigation-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
}
</style>
